import fetch from "../utils/fetch";
import { setAllowRedirect } from "./appActions";
import { redirectTo, alertBackendError } from "../utils";
import { USER, RESOURCES } from "../actions/constants";
import {getApiPrefix_lagoon, getApiPrefix_touch} from "../constants";

export const getUser = () => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource/DEFAULT`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();

      dispatch({
        type: USER,
        payload: content
      });

      return content;
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError( {response} );
    }

    return false;
  } catch (exception) {
    console.log(exception);
    alertBackendError( {exception} );
    return false;
  }
};

export const updateUser = user => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource/DEFAULT`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(user)
      }
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError( {response} );
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError( {exception} );
    return false;
  }
};

export const createAccount = id => async (dispatch, getState) => {
  if (!id) {
    return false;
  }

  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/requestToken/${id}/createAccount`,
      { method: "PUT" }
    );

    if (response.status === 500 || response.status === 503) {
      alertBackendError( {response} );
    }

    return response.status;
  } catch (exception) {
    console.log(exception);
    alertBackendError( {exception} );
    return false;
  }
};

export const getUsers = name => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/user${name && name !== "" ? `?name=${name}` : ""}`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();

      dispatch({
        type: RESOURCES,
        payload: { users: content }
      });
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError( {response} );
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError( {exception} );
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/actions/userActions.js